<template>
  <div class="sb-page">

    <!-- Hero -->
    <div class="sb-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-domain</v-icon>
        </v-avatar>
        <div>
          <div class="sb-hero__title">Sucursales por Sede</div>
          <div class="sb-hero__sub">Configuración de sucursales, puntos de venta y NIT</div>
        </div>
      </div>
      <v-btn small dark text @click="$router.back()">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
    </div>

    <div class="sb-body">

      <!-- Toolbar -->
      <v-card outlined class="sb-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex flex-wrap align-center" style="gap:10px;">
          <v-chip x-small :color="desserts.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ desserts.length }} sucursal{{ desserts.length !== 1 ? 'es' : '' }}
          </v-chip>
          <v-spacer />
          <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" />
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="sb-table-card">
        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="loading"
          :items-per-page="-1"
          hide-default-footer
          loader-height="3"
          loading-text="Cargando sucursales..."
          no-data-text="Sin sucursales registradas."
          dense
          class="sb-table"
        >
          <!-- Sede -->
          <template v-slot:[`item.sede`]="{ item }">
            <span class="font-weight-medium">{{ item.sede.nombre }}</span>
          </template>

          <!-- Sucursal -->
          <template v-slot:[`item.sucursal`]="{ item }">
            <span>
              <v-chip x-small color="indigo lighten-5" class="indigo--text text--darken-2 mr-1">
                {{ item.sucursal.numero_sucursal }}
              </v-chip>
              {{ item.sucursal.direccion }}
            </span>
          </template>

          <!-- Punto de venta -->
          <template v-slot:[`item.punto_venta`]="{ item }">
            <span v-if="item.punto_venta && item.punto_venta.nombre">
              <v-chip x-small color="teal lighten-5" class="teal--text text--darken-2 mr-1">
                {{ item.punto_venta.codigo_punto_venta }}
              </v-chip>
              {{ item.punto_venta.nombre }}
              <span class="grey--text text--lighten-1" v-if="item.punto_venta.descripcion">
                — {{ item.punto_venta.descripcion }}
              </span>
            </span>
            <span v-else class="grey--text" style="font-size:0.78rem;">—</span>
          </template>

          <!-- NIT número -->
          <template v-slot:[`item.xnitnro`]="{ item }">
            <span v-if="item.xnit" class="font-weight-medium">{{ item.xnit.nit }}</span>
            <span v-else class="grey--text" style="font-size:0.78rem;">—</span>
          </template>

          <!-- Tipo facturación -->
          <template v-slot:[`item.xnit`]="{ item }">
            <v-chip v-if="item.xnit" x-small label
              :color="item.iselectronica ? 'green lighten-5' : 'orange lighten-5'"
              :class="item.iselectronica ? 'green--text text--darken-3' : 'orange--text text--darken-3'"
              class="font-weight-medium">
              <v-icon left x-small>{{ item.iselectronica ? 'mdi-lightning-bolt' : 'mdi-receipt-text-outline' }}</v-icon>
              {{ item.xnit.tipo_facturacion }}
            </v-chip>
            <span v-else class="grey--text" style="font-size:0.78rem;">—</span>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="indigo darken-1" v-on="on" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar sucursal</span>
            </v-tooltip>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <SucursalesAM ref="unidadesam" v-on:newregsucursal="newregsucursal" />
    <SucursalesDEL ref="unidadesdel" />
    <Asignarsede ref="asignarsede" />
  </div>
</template>

<script>
import SucursalesAM from '@/views/Sucursales/Sucursalesam.vue';
import SucursalesDEL from '@/views/Sucursales/Sucursalesdel.vue';
import Asignarsede from '@/views/Sucursales/Asignarsede.vue';
import xaxios from '@/xaxios';

export default {
  components: { SucursalesAM, SucursalesDEL, Asignarsede },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    loading: false,
    headers: [
      { text: 'Sede',          value: 'sede' },
      { text: 'Sucursal',      value: 'sucursal' },
      { text: 'Punto de venta',value: 'punto_venta' },
      { text: 'NIT',           value: 'xnitnro',  width: 130 },
      { text: 'Tipo',          value: 'xnit',     width: 160 },
      { text: 'Opciones',      value: 'actions',  width: 80, sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: { name: '', calories: 0, fat: 0, carbs: 0, protein: 0 },
    defaultItem: { name: '', calories: 0, fat: 0, carbs: 0, protein: 0 },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
  },

  watch: {
    dialog(val) { val || this.close(); },
    dialogDelete(val) { val || this.closeDelete(); },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let idsede = this.$route.query.idsede;
      let vue = this;
      let peticiones = [];
      this.loading = true;
      xaxios.request({
        method: 'get',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${idsede}`,
        headers: {},
      }).then(function(response) {
        let data = response.data.data;
        window.console.log('>>>', data);
        data.map((x) => { x.iselectronica = false; });
        vue.desserts = data;
        vue.desserts.forEach((x) => {
          const promise = xaxios.get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${x.sede_id}`);
          peticiones.push(promise);
        });
        Promise.all(peticiones).then(function(values) {
          values.forEach((x) => {
            let idsuc = x.data.id;
            let s = vue.desserts.find((ss) => ss.sede_id == idsuc);
            if (s) s.xnit = x.data;
            if (s && x.data.tipo_facturacion.includes('ELECTR')) s.iselectronica = true;
            vue.loading = false;
          });
        }).catch((e) => {
          window.console.error(e);
          vue.loading = false;
        });
      }).catch(function(error) {
        vue.loading = false;
        window.console.log(error);
      });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$refs.unidadesam.openmodal(item);
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$refs.unidadesdel.openmodal();
    },

    asignarsede(item) {
      this.$refs.asignarsede.openmodal(item);
    },

    asignacionsedes(item) {
      this.$router.push(`/asignacionsede?idsucursal=${item.id}`);
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    newregsucursal(item) {
      window.console.log('newregsucursal', item);
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style scoped>
.sb-page { min-height: 100vh; background: #f5f7fa; }

.sb-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.sb-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.sb-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.sb-body { padding: 20px 24px; }

.sb-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.sb-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.sb-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.sb-table >>> tbody tr:hover { background: #f0f4ff !important; }
.sb-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
